module.exports = function joinURL() {
  let url = arguments[0]
  for (let i = 1; i < arguments.length; ++i) {
    url = url.replace(/\/$/, '') + '/' + arguments[i].replace(/^\//, '') //eslint-disable-line prefer-template
  }
  return url
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/common/joinURL.js